import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { log } from 'console';
import { ContractsService } from 'src/app/services/contracts/contracts.service';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { PlanService } from 'src/app/services/planService/plan.service';
import { ReporteService } from 'src/app/services/reportes/reporte.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-report-page',
  templateUrl: './report-page.component.html',
  styleUrls: ['./report-page.component.scss']
})
export class ReportPageComponent implements OnInit {

  public loader = true
  public data_source: any
  public displayColumns = ['client', 'agent', 'completeData', 'courtDate', 'nextCourtDate', 'callHours', "hourTask", "workHours", "plan", "planTime", "price", "vp", "vv", "percent", "horas_por_dia", "dias_de_uso", 'horas_por_periodo', 'porcentaje_proporcional']
  public contractsList = []
  public planLists = []
  constructor(
    private reportService: ReporteService,
    private activeRoute: ActivatedRoute,
    private contractService: ContractsService,
    private planService: PlanService,
    private excelService: ExcelService
  ) { }

  async ngOnInit() {
    var id = this.activeRoute.snapshot.paramMap.get('id') ?? ''
    if (id != '') {
      this.contractsList = await this.getContracts()
      this.planLists = await this.getPlans()
      this.data_source = await this.findReport(id)  
    }
    this.loader = false
  }

  private calculateDiasDeUso(courtDateInput: string | Date, startDate: Date, endDate: Date): number {
  if (!courtDateInput) return 0;

  const courtDate = courtDateInput instanceof Date
    ? courtDateInput
    : new Date(courtDateInput); // si es string, parseamos

  if (isNaN(courtDate.getTime())) return 0; // fallback si inválida

  // Normalizamos horas
  courtDate.setHours(0,0,0,0);
  const start = new Date(startDate); start.setHours(0,0,0,0);
  const end = new Date(endDate); end.setHours(0,0,0,0);

  // Días totales del rango del reporte
  const diasReporte = Math.floor((end.getTime() - start.getTime()) / (1000*60*60*24)) + 1;

  // 👉 Condición 3: si la fecha de corte es el día 1
  if (courtDate.getDate() === 1) {
    return diasReporte;
  }

  // Diferencia entre corte y fin del reporte
  const diffCorteFin = Math.floor((end.getTime() - courtDate.getTime()) / (1000*60*60*24)) + 1;

  // 👉 Condición 1: si la diferencia es menor a 10 días → usar los días del reporte
  if (diffCorteFin < 10) {
    return diasReporte;
  }

  // 👉 Condición 2: si es mayor a 10 días → usar desde corte hasta fin
  return diffCorteFin > 0 ? diffCorteFin : 0;
}

  async findReport(id: string) {
  try {
    const response = await this.reportService.findRankingReport(id);
    console.log('Reporte encontrado:', response);
    
    response.reportData.map((clientReport) => {
      // Datos de contrato y plan
      clientReport.contractData = this.contractsList.filter(c => c.clientId == clientReport.companyId)[0];
      clientReport.planData = this.planLists.filter(p => p.title == clientReport.plan)[0];

      // Calcular uso
      clientReport.usage =
        this.calculateUsedDates(
          clientReport.seconds_tareas,
          clientReport.seconds_llamadas,
          clientReport.planData
        );

      // HORAS POR DÍA
      const planTime = clientReport.planData ? parseInt(clientReport.planData.time) : 0;
      clientReport.horas_por_dia = planTime / 30; // 30 días por mes

      // PARSEAR FECHA DE CORTE
      let courtDate: Date = new Date();
      const courtDateStr = clientReport.contractData?.courtDate;
      if (courtDateStr) {
        const parts = courtDateStr.split(' '); // ["1", "sep.2025"]
        const day = parseInt(parts[0]);
        const monthStr = parts[1].replace('.', '').toLowerCase();
        const year = parseInt(parts[2]);
        const monthMap: any = {
          ene: 0, feb: 1, mar: 2, abr: 3, may: 4, jun: 5,
          jul: 6, ago: 7, sep: 8, oct: 9, nov: 10, dic: 11
        };
        const month = monthMap[monthStr];
        courtDate = new Date(year, month, day);
      }

      // DÍAS DE USO
      const startDate = new Date(response.startDate);
      const endDate = new Date(response.endDate);
      clientReport.dias_de_uso = this.calculateDiasDeUso(courtDate, startDate, endDate);

      // HORAS POR PERIODO
      clientReport.horas_por_periodo = clientReport.horas_por_dia * clientReport.dias_de_uso;

      // PORCENTAJE PROPORCIONAL
      clientReport.porcentaje_proporcional = planTime > 0 ? 
      (clientReport.horas_por_periodo / planTime) * 100 : 0;
    });

    // Ordenar por uso
    response.reportData.sort((a, b) => a.usage > b.usage ? -1 : 1);
    return response;

  } catch (error) {
    console.log(error);
    Swal.fire({ icon: 'error' });
  }
}


  private async getContracts() {
    try {
      var response = await this.contractService.get()
      return response.data
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error'
      })
    }
  }

  private async getPlans() {
    try {
      var response = await this.planService.getPlans()
      return response.data
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error'
      })
    }
  }

  calculateUsedDates(
  taskSeconds: number,
  callSeconds: number,
  planData: any
) {
  try {

    const taskHours =
      Number(planData?.time || 0);

    const callMinutes =
      Number(planData?.minutes || 0);

    const totalPlanMinutes =
      (taskHours * 60) +
      callMinutes;

    const totalUsedMinutes =
      (taskSeconds / 60) +
      (callSeconds / 60);

    if (totalPlanMinutes <= 0)
      return 0;

    return (
      totalUsedMinutes /
      totalPlanMinutes
    ) * 100;

  } catch (error) {

    console.log(error);
    return 0;
  }
}

  async excel() {
  try {
    const headers = [
      "Nombre del cliente",
      "Ejecutivo asignado", 
      "Fecha de Antigüedad",
      "Fecha de corte",
      "Próx. fecha de corte",
      "Total de horas en llamadas",
      "Total de horas en tareas", 
      "Total de horas trabajadas",
      "Plan",
      "Horas del plan",
      "Monto",
      "Valor pagado",
      "Valor venta",
      "% de Uso",
      "Horas/día",
      "Días de uso", 
      "Horas por Periodo",
      "% Proporcional"
    ];
    
    var dataToPrint = []
    for (const company of this.data_source.reportData) {
      // Validar que company y company.planData existan
      if (!company) continue;
      
      var executives = ""
      if (Array.isArray(company.agent)) {
        for (const executive of company.agent) {
          if (company.agent.length === 1) {
            executives = executive;
          } else {
            executives = executive + ", " + executives;
          }
        }
      } else {
        executives = "No agents available";
      }

      // VALIDACIÓN CRÍTICA: Verificar planData
      const planData = company.planData || {};
      const planTime = planData.time ? parseInt(planData.time) : 0;
      const planPrecio = planData.precio || 0;
      
      // Calcular valor pagado de forma segura (evitar división por cero)
      const valorPagado = planTime > 0 ? planPrecio / planTime : 0;

      var data = {
        "0": company.nombre_empresa || 'N/A',
        "1": executives,
        "2": company.companyDate ? formatDate(new Date(company.companyDate), 'dd/MM/yyyy', 'en-US') : 'N/A',
        "3": company?.courtDate && !isNaN(new Date(company.courtDate).getTime()) ? formatDate(new Date(company.courtDate), 'dd/MM/yyyy', 'en-US') : 'N/A',
       "4": company?.nextCourtDate && !isNaN(new Date(company.nextCourtDate).getTime()) ? formatDate(new Date(company.nextCourtDate), 'dd/MM/yyyy', 'en-US') : 'N/A',   
        "5": parseFloat(((company.seconds_llamadas || 0) / 3600).toFixed(2)),
        "6": parseFloat(((company.seconds_tareas || 0) / 3600).toFixed(2)),
        "7": parseFloat(((company.seconds_trabajo || 0) / 3600).toFixed(2)),
        "8": company.plan || 'Sin plan',
        "9": planTime + " hrs",
        "10": planPrecio,
        "11": valorPagado,
        "12": company.valueSale || 0,
        "13": ((company.usage || 0)).toFixed(2) + "%",
        "14": company.horas_por_dia ? parseFloat(company.horas_por_dia.toFixed(2)) : 0,
        "15": company.dias_de_uso || 0,
        "16": company.horas_por_periodo?.toFixed(2) || 0,
        "17": company.porcentaje_proporcional?.toFixed(2) + "%"
      }
      dataToPrint.push(data)
    }
    
    const fileName = "Reporte Ranking del " + formatDate(this.data_source.startDate, 'dd MMMM yyyy', 'es-MX') + ' al ' + formatDate(this.data_source.endDate, 'dd MMMM yyyy', 'es-MX')
    await this.excelService._createReport(dataToPrint, headers, fileName, "RENTABILIDAD POR CLIENTE", ["-"], [5, 8, 10, 11], [9, 10, 11])
  } catch (error) {
    console.log(error);
    Swal.fire({
      icon: 'error',
      title: 'Ocurrió un error al descargar el excel'
    })
  }
}

}
